import apiClient from '@/services/AccountClient'

export default {
  fetchEsimInfo (profileId) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/e-sim/profiles/${profileId}/info`
    )
  },
  fetchEsimOrders (profileId) {
    return apiClient.sendRequest(
      'GET',
      `api/admin/v1/e-sim/profiles/${profileId}/orders`
    )
  },
  changeEsim (profileId, iccid) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/e-sim/profiles/${profileId}/reissue/${iccid}`
    )
  },
  refundEsimFee (data) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/e-sim/refund-payment`,
      data
    )
  },
  linkEsimFee (data) {
    return apiClient.sendRequest(
      'POST',
      `api/admin/v1/e-sim/link-refund-payment`,
      data
    )
  }
}
